import { cva } from 'class-variance-authority';

export const contentWithImageVariants = cva('flex w-full items-stretch', {
  variants: {
    imagePosition: {
      left: ['flex-col md:flex-row'],
      right: ['flex-col md:flex-row-reverse'],
    },
  },
  defaultVariants: {
    imagePosition: 'left',
  },
});

export const contentWithImageImageVariants = cva('md:w-1/2 h-auto', {
  variants: {
    borderPosition: {
      none: ['border-none'],
      left: [
        'border-transparent border-r-[3px] lg:hover:border-red-500 transition-all duration-300',
      ],
      right: [
        'border-transparent border-l-[3px] lg:hover:border-red-500 transition-all duration-300',
      ],
    },
  },
});

export const contentWithImageChildrenVariants = cva('md:w-1/2 flex flex-col', {
  variants: {
    imagePosition: {
      left: ['md:pl-8 lg:pl-16', 'text-left'],
      right: ['md:pr-8 lg:pr-16', 'text-left'],
    },
  },
  defaultVariants: {
    imagePosition: 'left',
  },
});
